<template>
  <div class="convert-loading-box" ref="loadingContainer">
    <Spin :pointNum="8" :translateX="25" background="var(--base-primary-bgColor)"  />
    <div class="common-global-progress-box">
      <el-progress
        :show-text="false"
        :percentage="percentage"
        :stroke-width="8"
      >
      </el-progress>
      <div class="custom-text">{{ `${percentage}%` }}</div>
    </div>
    <div class="description-box">路径生成中</div>
  </div>
</template>

<script>
import Spin from "@/components/Spin.vue";
export default {
  data() {
    return {};
  },
  props: {
    percentage: Number,
  },
  components: {
    Spin,
  },
  mounted() {
    document.body.appendChild(this.$refs.loadingContainer);
  },
};
</script>

<style lang="less" scoped>
.convert-loading-box {
  position: absolute;
  top: 0px;
  width: 100%;
  height: 100%;
  background: var(--panel-loading-bg-color);
  z-index: 999;

  .spinnner-container {
    position: absolute;
    width: 0px;
    left: 50%;
    top: 45%;
  }

  .common-global-progress-box {
    position: relative;
    top: 50%;
    display: flex;
    width: 180px;
    margin: 15px auto;
    line-height: 12px;

    /deep/ .el-progress {
      width: 80%;
      .el-progress-bar {
        line-height: 12px;
        border: 1px solid var(--success-status-color);
        padding: 1px;
        border-radius: 10px;

        .el-progress-bar__outer {
          background-color: transparent !important;

          .el-progress-bar__inner {
            line-height: 12px;
            background: var(--process-bar-bg);
          }
        }
      }
    }

    .custom-text {
      color: var(--base-light-color7);
      margin-left: 10px;
    }
  }

  .description-box {
    position: relative;
    top: 50%;
    color: var(--base-light-color7);
    text-align: center;
  }
}
</style>